export const PRODUCT_PAGE_ALL_SLUG = 'produkter';
export const DOCUMENT_TYPE_PRODUCT_ALL_PAGE = 'commerce.productAllPage';
export const PRODUCT_ALL_PAGE_ID = 'commerceProductAllPage';
export const OBJECT_TYPE_PRODUCT_IMAGE_OVERLAY_PLACEMENT = 'commerce.productImageOverlayPlacement';
export const OBJECT_TYPE_PRODUCT_IMAGE_OVERLAYS = 'commerce.productImageOverlays';
export const OBJECT_TYPE_PRODUCT_IMAGES = 'commerce.productImages';
